import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    saasId: '200001',
    platformCode: 'INTERVENE',
    userType: 'CUSER',
    clientType: 'ADMIN',
    channelId: 'SUGARQ',
    accessToken: ''
  },
  mutations: {
    SET_ACCESS_TOKEN: (state,accessToken) =>{
      state.accessToken = accessToken
    }
  },
  actions: {
    setAccessToken: ({commit}, accessToken) => {
      commit("SET_ACCESS_TOKEN", accessToken)
    },
  }
})
